import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

/* pages */
import Main from "./pages/Main.jsx";
import Reference from "./pages/Reference.jsx";
import Menu from "./pages/Menu.jsx";

/* styles */
import "/styles/modern-normalize.css";
import "/styles/global.css";
import "/styles/utility.css";

export default function App() {
  return (
    <Router>
      <Menu />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/reference" element={<Reference />} />
      </Routes>
    </Router>
  );
}
